/** Admin: a read-only look at every live test. Trainers set and run their own tests; the admin only oversees. */
import { api } from '../../core/api.js';
import { html } from '../../core/html.js';
import { fmtDateTime } from '../../core/format.js';
import { banner, empty, pageHead, table, tag } from '../../ui/components.js';

const status = (t) => {
  if (!t.published) return tag('Draft', 'n');
  if (Date.now() < Date.parse(t.opens_at)) return tag('Scheduled', 'wn');
  return Date.now() <= Date.parse(t.closes_at) ? tag('Open now', 'ok') : tag('Closed', 'n');
};

const tests = {
  path: '/admin/tests',
  roles: ['admin'],
  title: 'Live tests',
  load: (ctx) => api.get('/admin/tests', { signal: ctx.signal }),
  view(d) {
    return html`${pageHead('Live tests', 'Set by trainers for their own batches. You can see how each one is going.')}
      ${banner('Trainers create, publish and review tests from their batch page. The admin does not set tests.', '', 'info')}
      ${d.tests.length
        ? html`<div class="mt">${table(['Test', 'Trainer', 'Opens', 'Length', 'Status', 'Started', 'Finished', 'Flagged'], d.tests.map((t) => [
          t.title, t.trainer, fmtDateTime(t.opens_at), `${t.duration_min} min`, status(t), t.started, t.submitted, t.flagged ? tag(String(t.flagged), 'wn') : '0'])) }</div>`
        : empty('clip', 'No tests yet', 'When a trainer sets a test it appears here.')}`;
  },
};

export const routes = [tests];
